import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ModalHeaderLeft');

function ModalHeaderLeft({ index, totalImages, ...props }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Text className={classes.text}>{`${index + 1}/${totalImages}`}</Text>
        </div>
    );
}

ModalHeaderLeft.propTypes = {
    index: PropTypes.number,
    totalImages: PropTypes.number,
};

export default memo(ModalHeaderLeft);
